// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { FC } from 'react';

import { StyledCopyright, StyledFooter } from './Styled';
import LogoAthome from '../../icons/LogoAthome';
import { Container } from '../../../styles/chime-react/CommonStyles';

export const AthomeFooter: FC = () => {
  return (
    <StyledFooter>
      <Container maxWidth="67.5rem">
        <LogoAthome />
        <StyledCopyright>
          Copyright (C) At Home
          Co.,Ltd.このサイトに掲載している情報の無断転載を禁止します。著作権はアットホーム（株）またはその情報提供者に帰属します。
        </StyledCopyright>
      </Container>
    </StyledFooter>
  );
};

AthomeFooter.displayName = 'AthomeFooter';

export default AthomeFooter;
